import { useContext } from "react"
import { Link, useNavigate } from "react-router-dom"
import UiContext from "../../context/uiProvider"
import Logout from "../logout"
import useUser from "../../hooks/useUser"
import { LARGE_TABLET, TABLET } from "../../utils/screenSize"
import DataContext from "../../context/dataProvider"
import { usePublicSiteId } from "../../contexts/PublicSiteContext"
import { isConstructionWalk } from "../../utils/publicSite"
import { useSelectedCompany } from "../../context/companyProvider"
import { formatCompanyContext } from "../../utils/companyAccess"
import ChangeCompanyButton from "../construction/ChangeCompanyButton"

export default function Navbar() {
  const { id } = useUser()
  const { sidebarOpen, deviceView } = useContext(UiContext)
  const { currentUser } = useContext(DataContext)
  const siteId = usePublicSiteId()
  const { selectedCompany, isAdmin, clearCompany } = useSelectedCompany()
  const navigate = useNavigate()

  const padding = deviceView >= LARGE_TABLET
    ? (sidebarOpen ? "pl-72" : "pl-28")
    : deviceView >= TABLET
      ? (sidebarOpen ? "pl-60" : "pl-28")
      : "pl-20"

  const showChangeCompany = isConstructionWalk(siteId) && isAdmin && Boolean(selectedCompany?.id)

  const handleChangeCompany = () => {
    clearCompany()
    navigate("/app/management-companies")
  }

  return (
    <nav className={`${padding} z-10 duration-300 ease-in w-full bg-slate-100 shadow-md h-12 flex items-center justify-between text-xl font-bold fixed px-8 text-black top-0`}>
      <Link to={`/app/users/${id}`} state={{ user: currentUser }} >
        <div>{currentUser.firstName + " " + currentUser.lastName}</div>
      </Link>
      <div className="flex items-center gap-3">
        {showChangeCompany && selectedCompany ? (
          <>
            <span className="hidden md:inline font-source text-base font-semibold text-primary-dark">
              {formatCompanyContext(selectedCompany)}
            </span>
            <ChangeCompanyButton onClick={handleChangeCompany} />
          </>
        ) : null}
        <Logout />
      </div>
    </nav>
  )
}
